import { useBackendApi } from './backendApi';
import { FileDto } from './fileService';
import { useEventsPublisher } from 'event-bus';
import { ShortProfile } from './Types';
import { SetupAreaVersionInfo } from './plansService';

export enum MarketRequestStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  PROCESSED = 'PROCESSED'
}

export interface AttachedFile {
  fileId: number;
  title: string;
  _file: FileDto;
}

export interface MarketRequest {
  id: number;
  name: string;
  description: string;
  status: MarketRequestStatus;
  resultDescription: string | null;
  attachedFiles: AttachedFile[];
  setupArea: number | null;
  createdAt: string; // ISO date string
  _createdBy: ShortProfile,
  _setupArea: SetupAreaVersionInfo
}

export interface CreateMarketRequestRequest {
  name: string;
  description: string;
  attachedFiles: AttachedFileRequest[];
}

export interface AttachedFileRequest {
  fileId: number;
  title: string;
}

export const MARKET_REQUESTS_UPDATED = 'MARKET_REQUESTS_UPDATED';

export function useMarketRequestsService() {
  const nekstApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const createMarketRequest = async (request: CreateMarketRequestRequest): Promise<MarketRequest> => {
    const result = await nekstApi.post('/marketrequests', request) as MarketRequest;
    eventsPublisher.publish(MARKET_REQUESTS_UPDATED, {});
    return result;
  };

  const getMarketRequests = async (): Promise<MarketRequest[]> => {
    return await nekstApi.get('/marketrequests') as MarketRequest[];
  };

  const getMarketRequest = async (id: number): Promise<MarketRequest> => {
    return await nekstApi.get(`/marketrequests/${id}`) as MarketRequest;
  };

  return {
    createMarketRequest,
    getMarketRequests,
    getMarketRequest
  };
}
